import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiFunnel, PiTrash } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { II18nextPrefix } from 'types/components/components.interface';

interface IQQueryFilterButtonsProps<T> extends II18nextPrefix {}

const QQueryFilterButtons = <T,>({
  i18nextPrefix,
}: IQQueryFilterButtonsProps<T>) => {
  const { t } = useTranslation();

  return (
    <div className='filter-form-buttons'>
      <Button type='submit' variant={BUTTON_VARIANT.submit}>
        <Button.Text text={t(`${i18nextPrefix}.filters.submit`)} />
        <Button.Icon icon={<PiFunnel />} />
      </Button>
      <Button type='reset' onlyIcon variant={BUTTON_VARIANT.remove}>
        <Button.Icon icon={<PiTrash />} />
      </Button>
    </div>
  );
};

export default QQueryFilterButtons;
